export default {
  admin: {
    title: "Usuarios",
    newUser: "+ Nuevo usuario",
    errorPrefix: "Error: ",
    userCreated: "Usuario creado",
    userUpdated: "Usuario actualizado",
    userDeleted: "Usuario eliminado",
    readonlyNoticePre: "El equipo de usuarios de tu organización lo gestiona HelixScan. Para añadir, modificar o dar de baja usuarios, escríbenos a ",
    readonlyNoticePost: ".",
    colName: "Nombre",
    colEmail: "Email",
    colRole: "Rol",
    colStatus: "Estado",
    colCreated: "Creado",
    colLastLogin: "Último acceso",
    colActions: "Acciones",
    you: "(tú)",
    active: "Activo",
    inactive: "Inactivo",
    never: "Nunca",
    edit: "Editar",
    activate: "Activar",
    deactivate: "Desactivar",
    delete: "Eliminar",
    noUsers: "Sin usuarios",
    confirmDeleteTitle: "¿Eliminar usuario?",
    confirmDeleteMsg: "Esta acción no se puede deshacer.",
    modalCreateTitle: "Nuevo usuario",
    modalEditTitle: "Editar usuario",
    fieldFirstName: "Nombre",
    fieldLastName: "Apellido",
    fieldEmail: "Email *",
    fieldPassword: "Contraseña *",
    fieldRole: "Rol",
    fieldNewPassword: "Nueva contraseña",
    fieldNewPasswordHint: "(dejar vacío para no cambiar)",
    cancel: "Cancelar",
    createUser: "Crear usuario",
    saveChanges: "Guardar cambios",
  },
};
